import '../chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.GmbRatingsRankingChartView extends Monitoring.Views.Charts.ChartView

  className: 'processing item gmb-ratings-ranking'
  template: JST['backbone/templates/monitoring/charts/gmb_ratings_ranking/container']
  url: "/monitoring/api/charts/gmb_ratings_ranking"

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'
    'click .gmb-stars-menu .dropdown-item': 'changeFirstLevel'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @levels = ['countries', 'provinces', 'cities', 'addresses']
    @_settings = @options.settings
    @_settings.firstLevel ||= @levels[0]
    @_settings.direction ||= 'desc'
    @container = @options.container
    @title = I18n.t('monitoring.dashboard.charts.gmb_ratings_ranking.title')
    @widget = null

  render: ->
    @$el.html(@template({
      title: @title
      firstLevel: @_settings.firstLevel
    }))
    @

  afterAppend: ->
    requestBody = _.extend({}, @getSearchQuery().toJSON(), { chart_settings: @_settings })
    @ajaxCall(@url, requestBody, (response) =>
      @$el.removeClass('processing')
      @createWidget(response)
    )

  createWidget: (firstLevelNodes) ->
    @widget = new VueInBackbone.VueComponent('gmb-ratings-ranking-widget', {
      firstLevelName: I18n.t("monitoring.dashboard.charts.gmb_ratings_ranking.#{@_settings.firstLevel}")
      firstLevelNodes: firstLevelNodes
      initialDirection: @_settings.direction
    })
    @vueContainer().append(@widget.el)
    @widget.render()
    @widget.on('change-direction', @changeDirection)
    @widget.on('preview-session', @previewSession)

  vueContainer: ->
    @$el.find('#gmb-stars')

  getSearchQuery: ->
    @searchQuery.deepCopy()

  changeDirection: (newDirection) =>
    @_settings.direction = newDirection
    @trigger('chartsChange')

  changeFirstLevel: (evt) ->
    selectedFirstLevel = $(evt.currentTarget).data('firstLevel')
    if selectedFirstLevel != @_settings.firstLevel
      @_settings.firstLevel = selectedFirstLevel
      @onChangeSettings()

  onChangeSettings: ->
    @$el.addClass('processing')
    @trigger('chartsChange')
    @widget.remove() unless @widget == null
    @render()
    @afterAppend()
    @addNoteBox()

  previewSession: (drilldownPath) =>
    query = @getPreviewSessionQuery(drilldownPath)
    @createPreviewDashboard(query)

  getPreviewSessionQuery: (drilldownPath) ->
    query = @searchQuery.deepCopy()
    indexOfFirstLevel = _.indexOf(@levels, @_settings.firstLevel) # 0, 1, 2 or 3

    _.each(drilldownPath, (currentPathElement, index) =>
      indexOfClickedLevel = indexOfFirstLevel + index # 0, 1, 2 or 3
      clickedLevel = @levels[indexOfClickedLevel]
      key = "gmb_#{clickedLevel}"
      query.set(key, currentPathElement.value)
    )

    return query

  destroy: ->
    @widget.remove() unless @widget == null
    super()
